import { SearchParamsOption } from 'ky';
import omitby from 'lodash.omitby';

import { IGetFermentations } from '../types/api';
import { IFermentation } from '../types/fermentation';

export const serializeGetFermentationsParams = ({
  page = 1,
  pageSize = 20,
  states,
  includeBatchCount = 1,
  group,
  ...params
}: IGetFermentations): SearchParamsOption => {
  const searchQuery = [
    ['page', page],
    ['page_size', pageSize],
    ['include_batch_count', includeBatchCount],
  ];
  const statesStr = states?.join(',');
  if (statesStr) searchQuery.push(['states', statesStr]);
  if (group) searchQuery.push(['group', group]);

  for (const [key, value] of Object.entries(params)) {
    if (key) searchQuery.push([key, value as string]);
  }
  return searchQuery;
};

export const serializeCreateFermentationParams = ({
  tags,
  scaleType,
  appVersion,
  fermentedAt,
  description,
  ...rest
}: Partial<IFermentation>) => {
  const data: any = {
    ...rest,
    desc: description,
    scale_type: scaleType,
    app_version: appVersion,
    fermented_at: fermentedAt,
  };

  if (tags) {
    data['tags'] = JSON.stringify({
      tag: omitby(
        {
          oculyze_wine_type: formatTag(tags.oculyzeWineType),
          tank_volume: formatTag(tags.tankVolume),
          tank: formatTag(tags.tank),
          grape_variety: formatTag(tags.grapeVariety),
          yeast_brand: formatTag(tags.yeastBrand),
          yeast_strain: formatTag(tags.yeastStrain),
          nutrients_at_fill_in: formatTag(tags.nutrientsAtFillIn),
          additives_at_fill_in: formatTag(tags.additivesAtFillIn),
          vineyard_source: formatTag(tags.vineyardSource),
          yeast_generation: formatTag(tags.yeastGeneration),
        },
        (v) => v === null,
      ),
    });
  }
  return data;
};

// remove undefined, null or empty strings from the payload
const formatTag = (value: any) => {
  if (value === undefined || value === null || value === '') return null;
  return [value];
};
